import SlideshowViewModal from './SlideshowViewModal';

export default SlideshowViewModal;
